// extracted by mini-css-extract-plugin
export default {"cls1":"StickyCtaFooter-cls1_lIQ","cls2":"StickyCtaFooter-cls2__I7 StickyCtaFooter-cls1_lIQ"};